import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';


// TODO: replace with your real config from Firebase Console
const firebaseConfig = {
      apiKey: "AIzaSyDO_B5E9ngZDWHw4DU34IkKp15QY5LlErU",
  authDomain: "nhe-news.firebaseapp.com",
  projectId: "nhe-news",
  storageBucket: "nhe-news.firebasestorage.app",
  messagingSenderId: "363346938089",
  appId: "1:363346938089:web:36b7fc041f1e9aaf650878",
  measurementId: "G-EFVN0R8YF6"
    // apiKey: "AIzaSyA99tNYYA0-XrC2HXwHsZnxtg5GlcNfn0U",
    // authDomain: "YOUR_PROJECT_ID.firebaseapp.com",
    // projectId: "nhenews",
    // storageBucket: "YOUR_PROJECT_ID.appspot.com",
    // messagingSenderId: "363346938089",
    // appId: "YOUR_APP_ID"
};


const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDO_B5E9ngZDWHw4DU34IkKp15QY5LlErU",
//   authDomain: "nhe-news.firebaseapp.com",
//   projectId: "nhe-news",
//   storageBucket: "nhe-news.firebasestorage.app",
//   messagingSenderId: "363346938089",
//   appId: "1:363346938089:web:36b7fc041f1e9aaf650878",
//   measurementId: "G-EFVN0R8YF6"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);